import {NgxFilterBaseComponent} from "../ngx-filter-base-component";

export abstract class NgxConditionSelectorFilter extends NgxFilterBaseComponent {

}
